import * as Sentry from '@sentry/react'

interface UserInfo {
  id: number | string
  nickname?: string | null
  membershipType?: string | null
  siteName?: string
}

let lastSetUserId: string | null = null

export function setSentryUser(user: UserInfo): void {
  const userIdStr = user.id.toString()

  if (lastSetUserId === userIdStr) {
    return
  }

  lastSetUserId = userIdStr

  Sentry.setUser({
    id: userIdStr,
    username: user.nickname || 'Anonymous Guest',
    email: user.siteName ? `${user.siteName}-${userIdStr}` : userIdStr,
  })

  if (user.siteName) {
    Sentry.setTag('site_name', user.siteName)
  }

  if (user.membershipType) {
    Sentry.setTag('membership_type', user.membershipType)
  }

  Sentry.setContext('digitane-typing', {
    userId: userIdStr,
    nickname: user.nickname || 'unknown',
    siteName: user.siteName || 'unknown',
    membershipType: user.membershipType || 'unknown',
    env: import.meta.env.MODE || 'unknown',
  })
}

export function clearSentryUser(): void {
  if (lastSetUserId === null) {
    return
  }

  lastSetUserId = null
  Sentry.setUser(null)
  Sentry.setTag('site_name', undefined)
  Sentry.setTag('membership_type', undefined)
  Sentry.setContext('digitane-typing', null)
}